import { BibliographicReference } from '@livv/models';

export const isValidBibliographicReferenceUrl = (url: string): boolean => {
    try {
        const { protocol } = new URL(url.trim());

        return protocol === 'http:' || protocol === 'https:';
    } catch {
        return false;
    }
};

export const getBibliographicReferenceUrl = (
    reference: BibliographicReference,
): string | undefined => {
    if (!reference.url || !isValidBibliographicReferenceUrl(reference.url)) {
        return undefined;
    }

    return reference.url.trim();
};
